import { render, staticRenderFns } from "./CartaoNotaFiscalEmitida.vue?vue&type=template&id=6ccd88ae&scoped=true"
import script from "./CartaoNotaFiscalEmitida.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoNotaFiscalEmitida.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoNotaFiscalEmitida.vue?vue&type=style&index=0&id=6ccd88ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccd88ae",
  null
  
)

export default component.exports